import { restApiClient } from '@/datasources';

interface UpdateAppointmentPatient {
  appointmentId: string;
  patientId: string;
}

export const updateAppointmentPatient = async ({
  appointmentId,
  patientId,
}: UpdateAppointmentPatient): Promise<void> => {
  await restApiClient.put<void>(`/online/customers/appointments/${appointmentId}/change-patient/`, {
    patientId,
  });
};
